const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://quyhoachpleiku-api.gialai.gov.vn/",
    domainUserSide: "http://localhost:3000",
    domainAdminSide: "https://quyhoachpleiku-admin.gialai.gov.vn",
    domainName: "",
    doMainNameGeoServer: "https://quyhoachpleiku-map.gialai.gov.vn/geoserver/wfs",
    doMainNameGeoServerWMS: "https://quyhoachpleiku-map.gialai.gov.vn/geoserver/pleiku/wms",
    datastore: "pleiku",
  },

  production: {
    api: "https://quyhoachpleiku-api.gialai.gov.vn/",
    domainUserSide: "https://quyhoachpleiku.gialai.gov.vn",
    domainAdminSide: "https://quyhoachpleiku-admin.gialai.gov.vn",
    domainName: "quyhoachpleiku.gialai.gov.vn",
    doMainNameGeoServer: "https://quyhoachpleiku-map.gialai.gov.vn/geoserver/wfs",
    doMainNameGeoServerWMS: "https://quyhoachpleiku-map.gialai.gov.vn/geoserver/pleiku/wms",
    datastore: "pleiku",
  },
};

module.exports = apiEnvironment[env];

// const env = process.env.NODE_ENV || "development";

// const apiEnvironment = {
//   development: {
//     api: "https://pleiku-api.cgis.asia/",
//     domainUserSide: "http://localhost:3000",
//     domainAdminSide: "https://quyhoachpleiku-admin.gialai.gov.vn",
//     domainName: "",
//     doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
//     doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/pleiku/wms",
//     datastore: "pleiku",
//   },

//   production: {
//     api: "https://pleiku-api.cgis.asia/",
//     domainUserSide: "https://pleiku.cgis.asia",
//     domainAdminSide: "https://admin.pleiku.cgis.asia",
//     domainName: "pleiku.cgis.asia",
//     doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
//     doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/pleiku/wms/",
//     datastore: "pleiku",
//   },
// };

// module.exports = apiEnvironment[env];